import { featureFlags } from '@seen/core/featureFlags'
import type { Intervention } from '@seen/core/models/care-plans/intervention'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'

/* The model treats Active as editable. This flag is the release gate: off,
 * choosing Active still hides the menu and locks roles, text, and owner. */
export function useInterventionIsEditable(intervention: Intervention): boolean {
  const activeStaysEditable = useFeatureFlag(
    featureFlags.interventionActiveEditable
  )
  if (intervention.status === 'active' && !activeStaysEditable) {
    return false
  }
  return intervention.isEditable
}
